export function deploymentEntryAssetFromHtml(html: string) {
  const match = html.match(/<script\b(?=[^>]*\btype=["']module["'])(?=[^>]*\bsrc=["']([^"']+)["'])[^>]*>/i);
  if (!match?.[1]) return null;
  try {
    return new URL(match[1], window.location.origin).pathname;
  } catch {
    return null;
  }
}

export function currentDeploymentEntryAsset() {
  const src = document.querySelector<HTMLScriptElement>('script[type="module"][src]')?.src;
  if (!src) return null;
  try {
    return new URL(src, window.location.origin).pathname;
  } catch {
    return null;
  }
}

export async function latestDeploymentEntryAsset(signal?: AbortSignal) {
  const response = await fetch(`/__edubgt-release.json?deployment-check=${Date.now()}`, {
    cache: "no-store",
    credentials: "same-origin",
    headers: { "Cache-Control": "no-cache" },
    signal,
  });
  if (!response.ok) return null;
  try {
    return deploymentEntryAssetFromRelease(await response.json());
  } catch {
    return null;
  }
}


export function deploymentEntryAssetFromRelease(value: unknown): string | null {
  if (!value || typeof value !== "object") return null;
  const { ready, sha, release, entry } = value as Record<string, unknown>;
  if (ready !== true || typeof sha !== "string" || !/^[a-f0-9]{40}$/.test(sha)
    || typeof release !== "string" || !new RegExp(`^${sha}-[0-9]+-[0-9]+$`).test(release)
    || typeof entry !== "string") return null;
  const prefix = `/edubgt-releases/${release}/assets/`;
  if (!entry.startsWith(prefix) || !/^[a-zA-Z0-9_-]+\.js$/.test(entry.slice(prefix.length))) return null;
  return entry;
}
